export const C = {
  blue:"#0C1F3F", blue2:"#1A3A6B", orange:"#E8593C", orange2:"#F2A623",
  gold:"#C9972A", gold2:"#E8C060", goldLight:"#F5E6B8",
  teal:"#0F6E56", green:"#2e7d32", red:"#c62828", amber:"#f57f17",
  bg:"#F4F6FA", bgLight:"#FAFBFC", border:"#D8E2EE", borderLight:"#E8ECEF", gray:"#5A6A7A", gray2:"#7A8A9A", dark:"#0C1F3F", white:"#fff",
  navy:"#081629", navy2:"#0C1F3F", navy3:"#142845"
};

export const SC = {
  new:{bg:"#dbeafe",c:"#1e40af"}, contacted:{bg:"#fef9c3",c:"#854d0e"},
  "in-progress":{bg:"#f3e8ff",c:"#6b21a8"}, converted:{bg:"#dcfce7",c:"#166534"},
  lost:{bg:"#fee2e2",c:"#991b1b"}, active:{bg:"#dcfce7",c:"#166534"},
  inactive:{bg:"#fee2e2",c:"#991b1b"}, open:{bg:"#dcfce7",c:"#166534"},
  closed:{bg:"#fee2e2",c:"#991b1b"}, published:{bg:"#dcfce7",c:"#166534"},
  draft:{bg:"#fef9c3",c:"#854d0e"}, delivered:{bg:"#dcfce7",c:"#166534"},
  shipped:{bg:"#dbeafe",c:"#1e40af"}, processing:{bg:"#f3e8ff",c:"#6b21a8"},
  pending:{bg:"#fef9c3",c:"#854d0e"}
};

export const G = {
  hero:"linear-gradient(150deg,#050e1f 0%,#081629 40%,#0f2545 100%)",
  orange:"linear-gradient(135deg,#E8593C,#F2A623)",
  gold:"linear-gradient(135deg,#C9972A,#E8C060)",
  orangeRadial:"radial-gradient(ellipse at 60% 40%,rgba(232,89,60,.12) 0%,transparent 65%)",
  goldRadial:"radial-gradient(ellipse at 60% 40%,rgba(201,151,42,.08) 0%,transparent 65%)",
  navyGold:"linear-gradient(150deg,#050e1f 0%,#0c1f3f 55%,#1a2e50 100%)",
};
